"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation applyPlatformFeesToAllOrganizations {
    applyPlatformFeesToAllOrganizations
  }
`;
exports.default = mutation;
//# sourceMappingURL=applyPlatformFeesToAllOrganizations.mutation.js.map